import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'styles/pages/DigitalTools/CargoesFlow/CargoesFlow.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')} id="about">
      <div className={cn('container')}>
        <div className={cn('about__image-box')}>
          <img
            className={cn('about__image')}
            src="/images/pages/DigitalTools/CargoesFlow/planet.png"
            alt="Cargoes Flow"
          />
        </div>
        <div className={cn('about__content')}>
          <h2 className={cn('about__title')}>What is CARGOES Flow?</h2>
          <p className={cn('about__description-paragraph')}>
            <span className={cn('about__text-bold')}>CARGOES Flow</span> is a product by DP World, the global enabler of trade
            operating in 54 countries and 120+ terminals.
          </p>
          <p className={cn('about__description-paragraph')}>
            <span className={cn('about__text-bold')}>CARGOES Flow</span> is an enterprise, multi-vendor tracking tool for sea,
            air and land. It benefits large companies working with multiple logistics vendors, providing a single window
            view.
          </p>
          <p className={cn('about__description-paragraph')}>
            <span className={cn('about__text-bold')}>CARGOES Flow</span> enables customers to make business critical decisions
            throughout the supply chain.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SectionAbout;
